module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.arrematante !== null) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('btn-status-confirmar', {
    ref: "confirmarStatus",
    attrs: {
      "Status": _vm.getStatus
    }
  }), _vm._v(" "), _c('btn-status-confirmar', {
    ref: "confirmarStatusDoc",
    attrs: {
      "Status": _vm.getStatusDocumento
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fade-in-down"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Arrematante")]), _vm._v(" "), _c('span', {
    staticClass: "label no-radius bg-dark"
  }), _vm._v(" "), _c('span', {
    staticClass: "label m-l-n-xxs no-radius bg-success "
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "visible-xs m-t-lg"
  }), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-sm btn-info pull-right pull-none-xs hidden-print",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.print($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print m-r-xs"
  }), _vm._v(" Imprimir\n            ")]), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-sm btn-default pull-right pull-none-xs m-r-sm hidden-print",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editarUsuario($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user-o m-r-xs"
  }), _vm._v(" Acesso\n            ")]), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-sm btn-default pull-right pull-none-xs m-r-sm hidden-print",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editar($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit m-r-xs"
  }), _vm._v(" Editar\n            ")]), _vm._v(" "), _c('btn-status', {
    staticClass: "pull-right pull-none-xs m-r-sm hidden-print",
    attrs: {
      "Status": _vm.getStatus,
      "value": _vm.arrematante.status
    },
    on: {
      "input": _vm.confirmarAlteracaoStatus
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "pull-right pull-none-xs hidden-print m-t-xs m-r",
    staticStyle: {
      "clear": "left"
    },
    attrs: {
      "to": {
        name: 'arrematantes',
        query: {
          page: this.$route.query.page
        }
      },
      "id": "voltar"
    }
  }, [_c('strong', {
    staticClass: "label no-radius bg-info"
  }, [_vm._v("Voltar")]), _vm._v(" para arrematantes\n            ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('h4', [_vm._v(_vm._s(_vm.arrematante.pessoa.nome))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.arrematante.apelido))]), _vm._v(" "), _vm._l((_vm.enderecoPrincipal), function(endereco) {
    return _c('p', [_vm._v("\n              " + _vm._s(endereco.logradouro) + _vm._s(endereco.numero && ', ' + endereco.numero) + " " + _vm._s(endereco.complemento &&
      endereco.complemento) + " "), _c('br'), _vm._v("\n              " + _vm._s(endereco.bairro) + " " + _vm._s(endereco.cep ? ', ' + endereco.cep : '')), _c('br'), _vm._v("\n              " + _vm._s(endereco.municipio ? endereco.municipio.nome : endereco.cidadeOutros) + ", " + _vm._s(endereco.municipio &&
      endereco.municipio.uf ? endereco.municipio.uf.nome : endereco.ufOutros) + "\n            ")])
  }), _vm._v(" "), _vm._l((_vm.outrosEnderecos), function(endereco) {
    return _c('p', {
      staticClass: "b-t"
    }, [_vm._v("\n              " + _vm._s(endereco.logradouro) + _vm._s(endereco.numero && ', ' + endereco.numero) + " " + _vm._s(endereco.complemento &&
      endereco.complemento) + " "), _c('br'), _vm._v("\n              " + _vm._s(endereco.bairro)), _c('br'), _vm._v("\n              " + _vm._s(endereco.municipio ? endereco.municipio.nome : endereco.cidadeOutros) + ", " + _vm._s(endereco.municipio &&
      endereco.municipio.uf ? endereco.municipio.uf.nome : endereco.ufOutros) + "\n            ")])
  }), _vm._v(" "), _c('p', _vm._l((_vm.arrematante.pessoa.telefones), function(telefone) {
    return _c('span', [_vm._v("Telefone: " + _vm._s(_vm._f("formataTelefone")(telefone.telefone))), (telefone.celular) ? _c('i', {
      staticClass: "fa fa-mobile-phone m-l-xs"
    }) : _vm._e(), _vm._v(" "), _c('br')])
  }), 0), _vm._v(" "), _c('p', [_vm._v("\n              Email" + _vm._s(_vm.arrematante.pessoa.emails && _vm.arrematante.pessoa.emails.length > 1 ? 's' : '') + ": "), _c('span', [_vm._v(_vm._s(_vm.getEmails))])]), _vm._v(" "), _c('p', [_vm._v("\n              IP origem cadastro: "), _c('span', [_vm._v(_vm._s(_vm.arrematante.pessoa.ipCadastro))])]), _vm._v(" "), (_vm.arrematante.observacao) ? _c('p', [_vm._v("\n              Observações:"), _c('br'), _c('br'), _vm._v("\n              " + _vm._s(_vm.arrematante.observacao) + "\n            ")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right text-left-print"
  }, [_c('p', {
    staticClass: "h4"
  }, [_vm._v("#" + _vm._s(_vm.arrematante.id))]), _vm._v(" "), _c('h5', [_vm._v("Se cadastrou" + _vm._s(_vm.arrematante.pessoa.origem ? ' pelo ' + _vm.arrematante.pessoa.origem.origem.toLowerCase() :
    '') + " " + _vm._s(_vm.moment(_vm.arrematante.pessoa.dataCadastro.date).format('LLLL')))]), _vm._v(" "), _c('div', [_vm._v("\n              " + _vm._s(_vm.arrematante.pessoa.tipo === 1 ? 'Pessoa Física' : 'Pessoa Jurídica')), _c('br'), _vm._v(" "), (_vm.arrematante.pessoa.tipo === 1) ? _c('div', [_vm._v("\n                CPF: "), (_vm.arrematante.pessoa.cpf) ? _c('span', [_vm._v(_vm._s(_vm._f("formataCpf")(_vm.arrematante.pessoa.cpf)))]) : _c('span', [_vm._v("Sem CPF")]), _c('br'), _vm._v("\n                RG: " + _vm._s(_vm.arrematante.pessoa.pfRg) + " " + _vm._s(_vm.arrematante.pessoa.pfRgOrgaoEmissor) + " " + _vm._s(_vm.arrematante.pessoa.pfRgDataExpedicao)), _c('br'), _vm._v("\n                Nascimento: "), (_vm.arrematante.pessoa.pfDataNascimento) ? _c('span', [_vm._v(_vm._s(_vm.moment(_vm.arrematante.pessoa.pfDataNascimento.date).format('L')) + ", " + _vm._s(_vm._f("moment")(_vm.arrematante.pessoa.pfDataNascimento.date)))]) : _vm._e(), _c('br'), _vm._v("\n                Estado Civil: " + _vm._s(_vm.Status().EstadoCivil[_vm.arrematante.pessoa.pfEstadoCivil])), _c('br'), _vm._v("\n                Sexo: " + _vm._s(_vm.arrematante.pessoa.pfSexo === 1 ? 'Masculino' : 'Feminino')), _c('br'), _vm._v(" "), (_vm.arrematante.conjugeNome) ? _c('div', [_vm._v("\n                  Cônjuge: " + _vm._s(_vm.arrematante.conjugeNome)), _c('br'), _vm._v("\n                  CPF Cônjuge: "), (_vm.arrematante.conjugeCpf) ? _c('span', [_vm._v(_vm._s(_vm._f("formataCpf")(_vm.arrematante.conjugeCpf)))]) : _c('span', [_vm._v("Sem CPF")]), _c('br'), _vm._v("\n                  RG Cônjuge: "), (_vm.arrematante.conjugeRg) ? _c('span', [_vm._v(_vm._s(_vm.arrematante.conjugeRg))]) : _c('span', [_vm._v("Sem RG")]), _c('br')]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.arrematante.pessoa.tipo === 2) ? _c('div', [_vm._v("\n                CNPJ: "), (_vm.arrematante.pessoa.cnpj) ? _c('span', [_vm._v(_vm._s(_vm._f("formataCnpj")(_vm.arrematante.pessoa.cnpj)))]) : _c('span', [_vm._v("Sem CNPJ")]), _c('br'), _vm._v("\n                Inscrição Estadual: " + _vm._s(_vm.arrematante.pessoa.pjInscricaoEstadual)), _c('br'), _vm._v("\n                Nome Fantasia: " + _vm._s(_vm.arrematante.pessoa.pjNomeFantasia)), _c('br'), _vm._v("\n                Razão Social: " + _vm._s(_vm.arrematante.pessoa.pjRazaoSocial)), _c('br'), _vm._v("\n                Responsável: " + _vm._s(_vm.arrematante.pessoa.pjResponsavel || _vm.arrematante.pjProprietarioNome)), _c('br'), _vm._v("\n                CPF: "), (_vm.arrematante.pjProprietarioCpf) ? _c('span', [_vm._v(_vm._s(_vm._f("formataCpf")(_vm.arrematante.pjProprietarioCpf)))]) : _c('span', [_vm._v("SEM CPF DO RESPONSÁVEL")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "panel wrapper-sm m-t b"
  }, [_c('table', {
    staticClass: "table table-condensed",
    attrs: {
      "width": "100%",
      "cellspacing": "2",
      "cellpadding": "2"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "width": "200"
    }
  }, [_vm._v("Situação do cadastro")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.Status().Status[_vm.arrematante.status].titulo))])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "200"
    }
  }, [_vm._v("Pode comprar sucata")]), _vm._v(" "), _c('td', [(_vm.arrematante.podeComprarSucata) ? _c('strong', [_vm._v("Sim")]) : _c('strong', {
    staticClass: "text-danger"
  }, [_vm._v("Não")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "200"
    }
  }, [_vm._v("Termo recebido")]), _vm._v(" "), _c('td', [(_vm.arrematante.termoRecebido) ? _c('strong', [_vm._v("Sim")]) : _c('strong', {
    staticClass: "text-danger"
  }, [_vm._v("Não")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "200"
    }
  }, [_vm._v("Interesse do arrematante")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.interesseArrematante))])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "200"
    }
  }, [_vm._v("Deseja receber newsletter")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.arrematante.newsletter ? 'Sim' : 'Não'))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "hidden-print"
  }, [(_vm.arrematante.status === 0) ? _c('div', {
    staticClass: "alert",
    class: {
      'alert-warning': !_vm.isApto, 'alert-success': _vm.isApto
    }
  }, [(_vm.isApto) ? _c('div', [_vm._v("Este arrematante "), _c('span', {
    staticClass: "text-success font-bold"
  }, [_vm._v("está apto para ser aprovado")]), _vm._v(", de acordo à aprovação dos documentos\n              verificados.\n            ")]) : _c('div', [_vm._v("Este arrematante "), _c('span', {
    staticClass: "text-danger font-bold"
  }, [_vm._v("não está apto para ser aprovado")]), _vm._v(".\n              Verifique a documentação obrigatória. Caso considere-o apto, é possível aprovar mesmo com esta\n              restrição.\n            ")])]) : _vm._e(), _vm._v(" "), _c('h4', [_vm._v("Documentos")]), _vm._v(" "), _c('div', {
    staticClass: "m-b"
  }, [_c('label', {
    staticClass: "i-switch i-switch-xs bg-success m-t-xs m-r"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editarDocumentos),
      expression: "editarDocumentos"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.editarDocumentos) ? _vm._i(_vm.editarDocumentos, null) > -1 : (_vm.editarDocumentos)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.editarDocumentos,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.editarDocumentos = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.editarDocumentos = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.editarDocumentos = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i')]), _vm._v(" Editar Documentos\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.arrematante.documentos), function(doc) {
    return _c('div', {
      staticClass: "col-lg-3 col-md-6 col-sm-6 clearfix"
    }, [_c('div', {
      staticClass: "panel wrapper-sm"
    }, [_c('table', {
      staticClass: "table table-condensed"
    }, [_c('tbody', [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('strong', [_vm._v(_vm._s(doc.documento.nome))]), _c('br'), _vm._v(" "), (doc.documento.obrigatorio) ? _c('i', {
      staticClass: "label label-xs label-warning font-normal"
    }, [_vm._v("Obrigatório")]) : _c('i', {
      staticClass: "label label-xs label-default font-normal"
    }, [_vm._v("Não Obrigatório")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Envio")]), _vm._v(" "), _c('td', [_c('div', [_c('strong', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(_vm.moment(doc.dataCadastro.date).format('L')) + " " + _vm._s(_vm.moment(doc.dataCadastro.date).format('LT')))])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Formato")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(doc.arquivo.split('.').pop().toUpperCase()))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Status")]), _vm._v(" "), _c('td', {
      class: 'text-' + _vm.DocumentoStatus(doc.status).class
    }, [_c('btn-status', {
      attrs: {
        "Status": _vm.getStatusDocumento,
        "value": doc.status
      },
      on: {
        "input": function($event) {
          return _vm.confirmarAlteracaoStatusDocumento(doc, $event)
        }
      }
    })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('a', {
      staticClass: "btn btn-default btn-block",
      attrs: {
        "title": doc.nome,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.downloadDocumento(doc.arquivoHash)
        }
      }
    }, [_vm._v("Visualizar Documento")])])]), _vm._v(" "), (_vm.editarDocumentos) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "2",
        "align": "center"
      }
    }, [_c('button', {
      staticClass: "btn btn-xs bg-danger",
      attrs: {
        "title": "Remover"
      },
      on: {
        "click": function($event) {
          return _vm.removeDocumento(doc.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])]) : _vm._e()])])])])
  }), _vm._v(" "), _vm._l((_vm.documentosRequeridosPendentes), function(doc) {
    return _c('div', {
      staticClass: "col-lg-3 col-md-6 col-sm-6 "
    }, [_c('div', {
      staticClass: "panel bg-white-opacity wrapper-sm"
    }, [_c('table', {
      staticClass: "table table-condensed"
    }, [_c('tbody', [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('strong', [_vm._v(_vm._s(doc.nome))]), _c('br'), _vm._v(" "), (doc.obrigatorio) ? _c('i', {
      staticClass: "label label-xs label-warning font-normal"
    }, [_vm._v("Obrigatório")]) : _c('i', {
      staticClass: "label label-xs label-default font-normal"
    }, [_vm._v("Não Obrigatório")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Envio")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("-")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Formato")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("-")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Status")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "btn-group dropdown"
    }, [_c('button', {
      staticClass: "btn btn-sm disabled",
      attrs: {
        "data-toggle": "dropdown",
        "tabindex": "1",
        "aria-expanded": "false"
      }
    }, [_c('i', {
      staticClass: "fa fa-warning m-r-xs"
    }), _vm._v(" Não enviado\n                        ")])])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('a', {
      staticClass: "btn btn-default disabled btn-block",
      attrs: {
        "target": "_blank"
      }
    }, [_vm._v("Aguardando Envio")])])]), _vm._v(" "), (_vm.editarDocumentos) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "2",
        "align": "center"
      }
    }, [_c('button', {
      staticClass: "btn btn-xs bg-info fileContainer",
      attrs: {
        "title": "Upload"
      }
    }, [_c('i', {
      staticClass: "fa fa-upload"
    }), _vm._v(" "), _c('input', {
      ref: 'fileDocumento' + doc.id,
      refInFor: true,
      attrs: {
        "type": "file"
      },
      on: {
        "change": function($event) {
          return _vm.uploadDocumento(doc.id, $event)
        }
      }
    })])])]) : _vm._e()])])])])
  })], 2)]), _vm._v(" "), (_vm.arrematante.apelido !== 'PLATEIA') ? _c('div', {}, [_c('h4', [_vm._v("Arremates")]), _vm._v(" "), _c('table-lotes', {
    staticClass: "m-b",
    attrs: {
      "arrematante": _vm.arrematante
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Participação em Leilões")]), _vm._v(" "), _c('div', {
    staticClass: "bg-black"
  }, [_c('div', {
    staticClass: "bg-black pos-rlt hidden-print",
    attrs: {
      "id": "tableLancesHead"
    }
  }, [_c('table', {
    staticClass: "table table-black bg-black m-b-none"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "33%"
    }
  }, [_vm._v("Data")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33%"
    }
  }, [_vm._v("Leilão")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33%"
    }
  }, [_vm._v("Lote")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33%"
    }
  }, [_vm._v("Valor")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "scroll-black scroll-lote"
  }, [_c('table', {
    staticClass: "table table-black table-lance-black-topneg",
    attrs: {
      "id": "tableLances"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "33%"
    }
  }, [_vm._v("Data")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33%"
    }
  }, [_vm._v("Leilão")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33%"
    }
  }, [_vm._v("Lote")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33%"
    }
  }, [_vm._v("Valor")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.lances), function(lance) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.moment(lance.data.date).format('L')) + " " + _vm._s(_vm.moment(lance.data.date).format('LTS')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(lance.leilaoTitulo))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "target": "_blank",
        "to": {
          name: 'lotes.visualizar',
          params: {
            leilao: lance.leilaoId,
            id: lance.loteId
          }
        }
      }
    }, [_vm._v("\n                      " + _vm._s(lance.loteTitulo) + "\n                    ")])], 1), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(lance.valor)))])])
  }), _vm._v(" "), ((!_vm.lances || _vm.lances.length === 0) && !_vm.lancesLoading) ? _c('tr', [_c('td', {
    staticClass: "no-borders",
    staticStyle: {
      "border-bottom": "none"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Nenhum lance")])])]) : _vm._e(), _vm._v(" "), (_vm.lancesLoading) ? _c('tr', [_c('td', {
    staticClass: "no-borders text-center",
    staticStyle: {
      "border-bottom": "none"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner m-t fa-2x"
  })])]) : _vm._e()], 2)])])])], 1) : _vm._e()])])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-642d8c5e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/arematantes/components/VisualizarArrematante.vue
// module id = 1743
// module chunks = 17